import * as React from 'react'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { Link, browserHistory } from 'react-router'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { LoadingAnimation } from '../../../../../components/LoadingAnimation'
import { Currency } from '../../../../../components/Currency'
import { FormError } from '../../../../../components/FormError'
import { Routes } from '../../../../../constants/Routes'
import { parseAndDownloadCSV, printHTML } from '../../../../../utilities/helpers'
import { API, IInventorySnapshot } from '@getgreenline/homi-shared'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  params: {
    inventorySnapshotId: string
  }
}

interface State {
  inventorySnapshot?: IInventorySnapshot
}

@inject('currentCompanyStore')
@observer
export class ViewInventorySnapshot extends React.Component<Props, State> {
  id = `inventory-snapshot-${new Date().getDate()}`

  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const company = this.props.currentCompanyStore!.company!
    const inventorySnapshotId = this.props.params.inventorySnapshotId
    API.getInventorySnapshotById(company.id, parseInt(inventorySnapshotId, 10)).then(
      (inventorySnapshot) => {
        this.setState({ inventorySnapshot })
      },
    )
  }

  export() {
    const inventorySnapshot = this.state.inventorySnapshot
    if (inventorySnapshot) {
      parseAndDownloadCSV(
        `inventory-snapshot-${inventorySnapshot.locationName}-${moment(
          inventorySnapshot.createDate,
        ).format('LLLL')}`,
        inventorySnapshot.products.map((p) => {
          return Object.assign({}, p, {
            retailPrice: p.retailPrice / 100,
            purchaseCost: p.purchaseCost / 100,
          })
        }),
      )
    }
  }

  print() {
    printHTML(this.id, `Inventory snapshot`)
  }

  render() {
    const company = this.props.currentCompanyStore!.company!
    const inventorySnapshot = this.state.inventorySnapshot

    if (!inventorySnapshot) {
      return (
        <div>
          <LoadingAnimation />
        </div>
      )
    } else {
      return (
        <div className='container'>
          <br />
          <div>
            <Link to={Routes.DASHBOARD_INVENTORY_SNAPSHOTS(company.id)}>
              <button className='btn btn-light mr-2'>
                <span className='fa fa-chevron-left mr-2' />
                Back
              </button>
            </Link>
            <button className='btn btn-light mr-2' onClick={() => this.print()}>
              <span className='fa fa-print mr-2' />
              Print
            </button>
            <button className='btn btn-light mr-2' onClick={() => this.export()}>
              <span className='fa fa-download mr-2' />
              Export
            </button>
          </div>
          <br />
          <div id={this.id}>
            <table className='table table-sm'>
              <tbody>
                <tr>
                  <td>Company</td>
                  <td>{inventorySnapshot.companyName}</td>
                </tr>
                <tr>
                  <td>Location</td>
                  <td>{inventorySnapshot.locationName}</td>
                </tr>
                <tr>
                  <td>Created</td>
                  <td>{moment(inventorySnapshot.createDate).format('LLLL')}</td>
                </tr>
                <tr>
                  <td>Created by</td>
                  <td>{inventorySnapshot.startingUserName}</td>
                </tr>
              </tbody>
            </table>
            <table className='table table-sm'>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Product</th>
                  <th>SKU</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                  <th>Retail price per unit</th>
                  <th>Wholesale cost per unit</th>
                </tr>
              </thead>
              <tbody>
                {inventorySnapshot.products.map((p) => {
                  return (
                    <tr key={p.productId}>
                      <td>{p.categoryName}</td>
                      <td>{p.productName}</td>
                      <td>{p.sku}</td>
                      <td>{p.quantity}</td>
                      <td>{p.unit}</td>
                      <td>
                        <Currency centValue={p.retailPrice} />
                      </td>
                      <td>
                        <Currency centValue={p.purchaseCost} />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <br />
        </div>
      )
    }
  }
}
